import React from 'react';
import { Link } from 'react-router-dom'
import {Row,Col} from 'react-bootstrap'
import moment from 'moment';
import SideBar from '../../Modules/Helper/SideBar'
import MdSettings from 'react-icons/lib/md/settings'
import Dialog from 'material-ui/Dialog';
import { withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { connect } from 'react-redux';
import * as actions from '../../../Actions/index.js';


class Header extends React.Component{
  constructor(props) {
      super(props);
      this.userDropDown = this.userDropDown.bind(this);
      this.settingDropDown = this.settingDropDown.bind(this);
      this.state = {
        user: 'deactivate',
        setting: 'deactivate',
        modalIsOpen: false,
      }
      this.onLogout= this.onLogout.bind(this);
      this.CheckAndopenModalBox = this.CheckAndopenModalBox.bind(this);
      this.openAlertPopUp = this.openAlertPopUp.bind(this);
      this.closeModalPopup= this.closeModalPopup.bind(this);
    }
    openAlertPopUp() {
      this.setState({modalIsOpen: true});
    }
    closeModalPopup(){
      this.setState({modalIsOpen: false});
    }
    CheckAndopenModalBox(e){
      this.setState({ user : 'deactivate',setting : 'deactivate' });
    }
    // componentDidMount() {
    //   this.props.fetchAllSubscriptions();
    // }
    // delete all local storage after logout
    onLogout() {
      window.localStorage.removeItem('agl-token');
      window.localStorage.removeItem('agl-username');
      window.localStorage.removeItem('temp_company_id');
      window.localStorage.removeItem('temp_user_id');
      window.localStorage.removeItem('userType');
      window.location.href = '/login';
    }
    userDropDown(){
      let value =  (this.state.user === 'deactivate') ? 'active' : 'deactivate' 
      if(value==='active'){
        this.setState({ user : value,setting : 'deactivate' });
      }else{
        this.setState({ user : value });
      }

    }
    settingDropDown(){
      let value =  (this.state.setting === 'deactivate') ? 'active' : 'deactivate';
      if(value==='active'){
        this.setState({ setting : value,user : 'deactivate' });
      }else{
        this.setState({ setting : value });
      }
      
    }
    isAdminType(){
      var usertype = window.localStorage.getItem('userType');
      let type = this.props.currentuser.loggedInUser.type;
      if(usertype==='3' && type == 3){
        return true;
      }else{
        return false;
      }
    }
    render() {
      let checkType= this.isAdminType();
      let compName = this.props.currentuser.company ? this.props.currentuser.company.name : '';
      let type = this.props.currentuser.currentUser ? this.props.currentuser.currentUser.type : null;

      const action = [
          <FlatButton
            label="No"
            primary={true}
            onClick={this.closeModalPopup}
          />,
          <RaisedButton
            label="Yes"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            href='/subscription-plan'
          />,

        ];
        return(<header>
                  <div className='container-fluid'>
                    <Row>
                      <Col xs={6}>
                        <div className="header-content">
                          <div className="header-nav-sec">
                            <ul className="icon-div display-flex">
                              <li className="show-mobile-menu">
                                <SideBar />
                              </li>
                              <li>
                                <figure>
                                  <Link to="/">
                                    <img src="/images/logo_white.png"  alt="logo" />
                                  </Link>
                                </figure>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="header-content">
                          <div className="header-nav-sec">
                            <ul className="icon-div right-nav display-flex" onMouseLeave={this.CheckAndopenModalBox}>
                              <li className="hidden-xs" style={{'color':'#fff'}}>
                                  {compName}
                              </li>
                              {type===1?
                              <li  onClick={this.settingDropDown}>
                                <MdSettings className="menu-bar" />
                                   <div className={`drop-down-user ${this.state.setting}`}>
                                    <ul>
                                      <li>
                                        <Link to="/company"><i className="zmdi zmdi-balance"></i> Company</Link>
                                      </li>
                                      <li>
                                        <Link to="/user-account"><i className="zmdi zmdi-accounts"></i> Users</Link>
                                      </li>
                                    </ul>
                                  </div>  
                              </li>
                              : null}
                              <li onClick={this.userDropDown}>
                                <i className="zmdi zmdi-account" ></i>
                                 <div className={`drop-down-user ${this.state.user}`}>
                                  <ul>
                                  {!checkType?
                                    <li>
                                      <Link to="/change-password"><i className="zmdi zmdi-lock"></i> Password</Link>
                                    </li>
                                    : null }
                                    <li>
                                      <Link to="#" onClick={this.onLogout}><i className="zmdi zmdi-power"></i> Sign Out</Link>
                                    </li>
                                  </ul>
                                </div>  
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
               </header>
            )
    }
} 

const mapStateToProps= (state,props)=> {
    return {
      currentuser : state.login,
      subscriptionPlan: state.subscription,
      jobs: state.jobs,
    };
}
export default connect(mapStateToProps,actions)(withRouter(Header));


// WEBPACK FOOTER //
// ./src/Components/Modules/Includes/Header.js